import Modal from "../Modal/Modal";
import { companyName } from "../../../constants/constants";

type InstallAppModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const InstallAppModal = ({ isOpen, onClose }: InstallAppModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={`Add ${companyName} to your home screen`}
    panelClassName="max-w-lg"
  >
    <div className="space-y-5 text-left text-sm text-myteengig-text-muted">
      <p>
        Some browsers let us open the install prompt directly. If yours does not, use the steps below to save {companyName} like an app.
      </p>
      <div className="rounded-xl border border-myteengig-border bg-myteengig-background/70 p-4">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-myteengig-text-primary">iPhone or iPad</h3>
        <p className="mt-2">Open this site in Safari, tap the Share button, then choose `Add to Home Screen`.</p>
      </div>
      <div className="rounded-xl border border-myteengig-border bg-myteengig-background/70 p-4">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-myteengig-text-primary">Android</h3>
        <p className="mt-2">Open this site in Chrome, tap the browser menu, then choose `Install app` or `Add to Home screen`.</p>
      </div>
      <div className="rounded-xl border border-myteengig-border bg-myteengig-background/70 p-4">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-myteengig-text-primary">Desktop Chrome or Edge</h3>
        <p className="mt-2">Look for the install icon in the address bar, or open the browser menu and choose `Install {companyName}`.</p>
      </div>
    </div>
  </Modal>
);

export default InstallAppModal;
